import { createContext, useContext } from 'react';
import {
  getDefaultTimeRange,
  getRangeByKey,
  type TimeRange,
} from '@/components/TimeRangeSelector';

/**
 * KIR-5693: the range the dashboard's time-ranged widgets open on: `1d` for a
 * very busy organization (7-day views over its findings are slow to build),
 * else `7d`. The Dashboard page provides it once it knows; a widget opens on
 * it, and a range picked in the widget stands.
 */
export type DashboardDefaultRange = '1d' | '7d';

export const DashboardDefaultRangeContext =
  createContext<DashboardDefaultRange>('7d');

export function useDashboardDefaultRangeKey(): DashboardDefaultRange {
  return useContext(DashboardDefaultRangeContext);
}

/** The opening range for `key` in time zone `zone`. */
export function dashboardDefaultTimeRange(
  key: DashboardDefaultRange,
  zone?: string
): TimeRange {
  const oneDay = key === '1d' ? getRangeByKey('1d') : null;
  return oneDay
    ? { mode: 'relative', preset: '1d', ...oneDay.getRange(zone) }
    : getDefaultTimeRange(zone);
}
